export const DIAS_SEMANA = [
  { value: 0, label: "Domingo" },
  { value: 1, label: "Lunes" },
  { value: 2, label: "Martes" },
  { value: 3, label: "Miércoles" },
  { value: 4, label: "Jueves" },
  { value: 5, label: "Viernes" },
  { value: 6, label: "Sábado" },
];

const LOCALSTORAGE_KEY = "diaInicioSemanaCobranza";

export const leerDiaInicioSemanaGuardado = () => {
  const guardado = Number(window.localStorage.getItem(LOCALSTORAGE_KEY));
  return DIAS_SEMANA.some((dia) => dia.value === guardado) ? guardado : 0;
};

export const guardarDiaInicioSemana = (valor) => {
  window.localStorage.setItem(LOCALSTORAGE_KEY, String(valor));
};

const LOCALSTORAGE_KEY_MAQUINARIA = "separarMaquinariaCobranza";

// Activado por default: si la empresa no tiene el insumo "RENTA DE MAQUINARIA"
// no cambia nada en el reporte, asi que dejarlo prendido es seguro para todos.
export const leerSepararMaquinariaGuardado = () => {
  const guardado = window.localStorage.getItem(LOCALSTORAGE_KEY_MAQUINARIA);
  return guardado === null ? true : guardado === "true";
};

export const guardarSepararMaquinaria = (valor) => {
  window.localStorage.setItem(LOCALSTORAGE_KEY_MAQUINARIA, String(valor));
};

const LOCALSTORAGE_KEY_MATERIALES = "separarMaterialesCobranza";

// Activado por default: si la empresa no tiene la familia "SUMINISTRO DE
// MATERIALES" no cambia nada en el reporte, igual que con la maquinaria.
export const leerSepararMaterialesGuardado = () => {
  const guardado = window.localStorage.getItem(LOCALSTORAGE_KEY_MATERIALES);
  return guardado === null ? true : guardado === "true";
};

export const guardarSepararMateriales = (valor) => {
  window.localStorage.setItem(LOCALSTORAGE_KEY_MATERIALES, String(valor));
};
